export default "__VITE_ASSET__53b358ec__"